var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "approval" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "el-form",
          {
            ref: "formApproval",
            attrs: {
              size: "mini",
              model: _vm.approvalModel,
              "label-width": "100px"
            },
            nativeOn: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "审批名称",
                  prop: "approvalName",
                  rules: _vm.rules.approvalName
                }
              },
              [
                _c("el-input", {
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: "请输入审批名称" },
                  model: {
                    value: _vm.approvalModel.approvalName,
                    callback: function($$v) {
                      _vm.$set(_vm.approvalModel, "approvalName", $$v)
                    },
                    expression: "approvalModel.approvalName"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "审批类型",
                  prop: "approvalType",
                  rules: _vm.rules.approvalType
                }
              },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.approvalModel.approvalType,
                      callback: function($$v) {
                        _vm.$set(_vm.approvalModel, "approvalType", $$v)
                      },
                      expression: "approvalModel.approvalType"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [
                      _vm._v("顺序审批（按先后顺序审批）")
                    ]),
                    _c("el-radio", { attrs: { label: 2 } }, [
                      _vm._v("会审 （无顺序，全员通过则通过）")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "p",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _vm._v("审批复用  \n          "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content:
                            "开启后，若审批人已参与同一合同的发起审批，则在成员发起用印申请时无需再次审批。",
                          placement: "top-end"
                        }
                      },
                      [_c("i", { staticClass: "el-icon-question" })]
                    )
                  ],
                  1
                ),
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.approvalModel.useFileAuditFlag,
                      callback: function($$v) {
                        _vm.$set(_vm.approvalModel, "useFileAuditFlag", $$v)
                      },
                      expression: "approvalModel.useFileAuditFlag"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开")]),
                    _c("el-radio", { attrs: { label: 2 } }, [_vm._v("关")])
                  ],
                  1
                )
              ],
              1
            ),
            _c("el-form-item", { attrs: { label: "审批流程" } }, [
              _c(
                "div",
                { staticStyle: { display: "inline", position: "relative" } },
                [
                  _c(
                    "div",
                    { staticClass: "flow-sty" },
                    _vm._l(_vm.flows, function(user) {
                      return _c(
                        "div",
                        { key: user.emplId, staticClass: "box-sty" },
                        [
                          _c("p", { staticClass: "men-item" }, [
                            _c("img", {
                              attrs: {
                                src: "/images/web/p-default.png",
                                width: "50px",
                                height: "50px",
                                alt: ""
                              }
                            }),
                            _c("span", [_vm._v(_vm._s(user.name))]),
                            _c("span", {
                              staticClass: "item-close close_icon",
                              on: {
                                click: function($event) {
                                  return _vm.delUser(user)
                                }
                              }
                            })
                          ]),
                          _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.approvalModel.approvalType === 1,
                                expression: "approvalModel.approvalType === 1"
                              }
                            ],
                            staticClass: "icon icon-audit-jiantou32",
                            staticStyle: { width: "30px" }
                          })
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "el-popover",
                    { attrs: { placement: "right" } },
                    [
                      _c("div", { staticStyle: { padding: "20px" } }, [
                        _c(
                          "p",
                          { staticStyle: { "margin-bottom": "20px" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { width: "125px" },
                                attrs: { size: "mini" },
                                on: { click: _vm.addManager }
                              },
                              [_vm._v("添加直属部门主管")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "p",
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { width: "125px" },
                                attrs: { size: "mini" },
                                on: { click: _vm.handleClickFlowPlus }
                              },
                              [_vm._v("选择成员")]
                            )
                          ],
                          1
                        )
                      ]),
                      _c("plus", {
                        attrs: { slot: "reference" },
                        slot: "reference"
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "footer", staticStyle: { "text-align": "right" } },
      [
        _c(
          "el-button",
          { attrs: { size: "mini" }, on: { click: _vm.approvalCancel } },
          [_vm._v("取消")]
        ),
        _c(
          "el-button",
          {
            staticStyle: { "margin-right": "50px" },
            attrs: { size: "mini", type: "danger" },
            on: { click: _vm.approvalOk }
          },
          [_vm._v("确定")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47c55f98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c55f98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/dingComponents/dingSignApproval.vue
// module id = juS1
// module chunks = 7 30 56 108